import { CircularProgress, Grid, Paper } from "@mui/material";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "components/atoms/text";
import ReactWordcloud, { Scale, Spiral, Word } from "react-wordcloud";
import { customOrange } from "core/theme/variants";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";

interface Props {
  isReportLoading: boolean;
  wordCloud?: { text: string; value: number }[];
}

const WordCloudContent: FunctionComponent<Props> = ({
  isReportLoading,
  wordCloud,
}) => {
  const { t } = useTranslation();

  const options = {
    colors: [customOrange[900], customOrange[500], customOrange[100]],
    enableTooltip: true,
    deterministic: false,
    fontSizes: [5, 60] as [number, number],
    fontStyle: "normal",
    fontWeight: "normal",
    padding: 1,
    rotations: 3,
    rotationAngles: [0, 90] as [number, number],
    scale: "sqrt" as Scale,
    spiral: "archimedean" as Spiral,
    maxWith: "100px",
    maxHeight: "100px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transitionDuration: 1000,
  };

  const callbacks = {
    getWordTooltip: (word: Word) =>
      `${t("social-reports.word.tooltip.first_part")} "${word.text}" ${t(
        "social-reports.word.tooltip.second_part"
      )} ${word.value} ${t("social-reports.word.tooltip.third_part")}.`,
  };

  return (
    <Paper
      sx={{
        borderRadius: "10px",
        padding: "20px 0px",
      }}
    >
      <Text fontSize={"18px"} fontWeight={"600"} pb={"15px"}>
        {t("social-reports.word.title")}
      </Text>
      {isReportLoading ? (
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <CircularProgress color="secondary" size={"100px"} />
        </div>
      ) : (
        <Grid container display={"flex"} justifyContent={"center"}>
          {wordCloud && (
            <div style={{ width: "50vw", height: "40vh", margin: "auto" }}>
              <ReactWordcloud
                callbacks={callbacks}
                options={options}
                words={wordCloud}
              />
            </div>
          )}
        </Grid>
      )}
    </Paper>
  );
};

export default WordCloudContent;
